import React, { useContext } from 'react';
import SearchBarButton from './SearchBarButton';
import { HistoryDispatchContext } from '../providers/HistoryProvider';
import { TabStateContext } from '../providers/TabProvider';

export default function HomeButton() {
  const { activeTab } = useContext(TabStateContext);
  const dispatch = useContext(HistoryDispatchContext);
  const homeButtonClick = () => {
    dispatch({
      type: 'new',
      activeTab
    });
  }

  return (
    <SearchBarButton onClick={homeButtonClick}>
      <i className="icofont-ui-home"
        style={{ fontSize: '13px', lineHeight: '27px' }}></i>
    </SearchBarButton>
  );
}
